export default __webpack_public_path__ + "static/media/appliances_dark.3bd5efa0.png";